'use strict';exports.__esModule = true;var _PublishPropertyFormConstants = require('../containers/PublishForm/PublishPropertyFormConstants');

var formatCurrency = function formatCurrency(currency) {
  switch (currency) {
    case _PublishPropertyFormConstants.currencies.ILS:return '₪';
    case _PublishPropertyFormConstants.currencies.USD:return '$';
    case _PublishPropertyFormConstants.currencies.EUR:return '€';
    default:return '₪';}

};exports.default =

formatCurrency;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formatCurrency.js
// module id = 143
// module chunks = 0